var Span, _;

_ = require('underscore-plus');

Span = (function() {
  function Span(string1) {
    this.string = string1 != null ? string1 : '';
    this.indexParent = null;
  }

  Span.prototype.clone = function() {
    return new this.constructor(this.string);
  };

  Span.prototype.split = function(location) {
    var clone;
    if (location === 0 || location === this.getLength()) {
      return null;
    }
    clone = this.clone();
    clone.deleteRange(0, location);
    this.deleteRange(location, this.getLength() - location);
    return clone;
  };

  Span.prototype.mergeWithSpan = function(span) {
    return false;
  };


  /*
  Section: Characters
   */

  Span.prototype.getLocation = function() {
    return this.indexParent.getLocation(this) || 0;
  };

  Span.prototype.getLength = function() {
    return this.string.length;
  };

  Span.prototype.getEnd = function() {
    return this.getLocation() + this.getLength();
  };

  Span.prototype.getString = function() {
    return this.string;
  };

  Span.prototype.setString = function(string) {
    var delta, each;
    if (string == null) {
      string = '';
    }
    delta = string.length - this.string.length;
    this.string = string;
    if (delta) {
      each = this.indexParent;
      while (each) {
        each.length += delta;
        each = each.indexParent;
      }
    }
    return this;
  };

  Span.prototype.replaceRange = function(location, length, string) {
    var newString;
    newString = this.string.substr(0, location) + string + this.string.slice(location + length);
    return this.setString(newString);
  };

  Span.prototype.deleteRange = function(location, length) {
    return this.replaceRange(location, length, '');
  };

  Span.prototype.insertString = function(location, string) {
    return this.replaceRange(location, 0, string);
  };

  Span.prototype.appendString = function(string) {
    return this.insertString(this.getLength(), string);
  };


  /*
  Section: Spans
   */

  Span.prototype.getRoot = function() {
    var each;
    each = this.indexParent;
    while (each) {
      if (each.isRoot) {
        return each;
      }
      each = each.indexParent;
    }
    return null;
  };

  Span.prototype.getSpanIndex = function() {
    return this.indexParent.getSpanIndex(this);
  };

  Span.prototype.getSpanCount = function() {
    return 1;
  };


  /*
  Section: Debug
   */

  Span.prototype.toString = function(extra) {
    if (extra) {
      return "(" + (this.getString()) + "/" + extra + ")";
    } else {
      return "(" + (this.getString()) + ")";
    }
  };

  return Span;

})();

module.exports = Span;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/span-buffer/span.js
 ** module id = 13
 ** module chunks = 0
 **/